// Map a country name or ISO code to a flag emoji. Returns '' when unknown so
// callers can simply skip rendering. Country data comes through with customers
// (wq_paid_customers.country) and with visitors (IP geo).

const NAME_TO_ISO2: Record<string, string> = {
  uk: 'GB', 'united kingdom': 'GB', england: 'GB', britain: 'GB', 'great britain': 'GB', gb: 'GB', scotland: 'GB', wales: 'GB',
  us: 'US', usa: 'US', 'united states': 'US', 'united states of america': 'US', america: 'US',
  ireland: 'IE', australia: 'AU', canada: 'CA', india: 'IN', france: 'FR', germany: 'DE', spain: 'ES',
  italy: 'IT', netherlands: 'NL', holland: 'NL', 'new zealand': 'NZ', 'south africa': 'ZA',
  uae: 'AE', 'united arab emirates': 'AE', dubai: 'AE', singapore: 'SG', japan: 'JP', china: 'CN',
  brazil: 'BR', mexico: 'MX', portugal: 'PT', sweden: 'SE', norway: 'NO', denmark: 'DK', finland: 'FI',
  poland: 'PL', belgium: 'BE', switzerland: 'CH', austria: 'AT', greece: 'GR', turkey: 'TR',
}

export function countryToFlag(country?: string | null): string {
  if (!country) return ''
  const c = String(country).trim()
  if (!c) return ''
  let iso = ''
  if (/^[A-Za-z]{2}$/.test(c)) iso = c.toUpperCase()
  else iso = NAME_TO_ISO2[c.toLowerCase()] || ''
  if (!/^[A-Z]{2}$/.test(iso)) return ''
  try {
    return String.fromCodePoint(...[...iso].map((ch) => 0x1f1e6 + (ch.charCodeAt(0) - 65)))
  } catch {
    return ''
  }
}
